@if (liveAssetManagementService.isViewerPage()) {
  @if (canCreateInspection) {
    <evc-nav-button type="cta" size="xxl" variant="round" *callToAction  (click)="createInspection()">
      <span class="top-cta-label">{{ "liveAssets.useForInspection" | translate }}</span>
      <evc-svg-icon size="md" [icon]="'plus'"></evc-svg-icon>
    </evc-nav-button>
  }
}

@if (!liveAssetManagementService.isViewerPage()) {
  @if (canCreateAsset) {
    <evc-nav-button type="cta" size="xxl" variant="round" *callToAction (click)="addLiveAsset()">
      <span class="top-cta-label">{{ "liveAssets.createLiveAsset" | translate }}</span>
      <evc-svg-icon size="md" [icon]="'plus'"></evc-svg-icon>
    </evc-nav-button>
  }
}
<live-assets></live-assets>
